import { ContactDetailsWrapper } from '../../../../../../Components/City/Form/Ambassador/ContactDetailsWrapper'
import { Col, Row } from 'react-bootstrap'
import { Field, reduxForm } from 'redux-form'
import React from 'react'

import { Input } from 'Components/Form/Input'
import { Dropzone } from 'Components/Form/Dropzone'
import SubmitButton from 'Components/Form/SubmitButton'
import { SelectDashboard } from 'Components/Form/SelectDashboard'
import { SubmitButtonBlock } from 'Components/Form/SubmitButton/SubmitButtonBlock'
import {
  businessNumberTitle,
  countrySearch,
} from '../../../../../Form/City/Ambassador/ContactDetails'

const ContactForm = props => {
  const { spy, citiesOptions, handleSubmit, cities } = props

  return (
    <form>
      <ContactDetailsWrapper>
        <Col xs={2}>
          <Col xs={3}>
            <Field
              component={Dropzone}
              name="profilePicture"
              src={spy.profilePicture}
            />
          </Col>
        </Col>
        <Col xs={10}>
          <Row>
            <Col xs={3}>
              <p className="col-title">Email Address</p>
              <p className="email">{spy.email}</p>
            </Col>
            <Col xs={3}>
              <p className="col-title">First Name</p>
              <Field name="firstName" id="firstName" component={Input} />
            </Col>
            <Col xs={3}>
              <p className="col-title">Last Name</p>
              <Field name="lastName" id="lastname" component={Input} />
            </Col>
          </Row>
          <Row>
            <Col xs={3}>
              <p className="col-title">Phone number</p>
              <Field component={Input} name="mobilePhone" id="mobilePhone" />
            </Col>
            {countrySearch(spy, cities) !== 'US' && (
              <Col xs={3}>
                <p className="col-title">
                  {businessNumberTitle(countrySearch(spy, cities))}--
                </p>
                <Field component={Input} name="abn" id="abn" />
              </Col>
            )}
          </Row>
          <Row>
            <Col xs={3}>
              <p className="col-title">City</p>
              <Field
                name="cityId"
                component={SelectDashboard}
                options={citiesOptions}
                props={{ sorted: true }}
              />
            </Col>
          </Row>
        </Col>
      </ContactDetailsWrapper>
      <Row>
        <SubmitButtonBlock>
          <SubmitButton value="Save" onClick={handleSubmit} />
        </SubmitButtonBlock>
      </Row>
    </form>
  )
}

export default reduxForm({
  form: 'ambassador-contact-details-form',
  enableReinitialize: true,
})(ContactForm)



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Spies/Components/ContactForm/index.js